module.exports = __webpack_public_path__ + "img/viradoojogobr.d6c1f7e3.png";